import { useState } from "react";
import { Alert, Spin } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApiError } from "../api/client";
import { useFactory } from "../api/factories";
import { PageHead } from "../components/dashboard/Kpi";
import { Crumbs } from "../components/Crumbs";
import { FactoryView } from "../components/factory/FactoryDrawer";
import { FactoryName } from "../components/factory/FactoryTable";
import { AuditFormModal } from "../components/audit/AuditFormModal";

/** Pagina dello stabilimento (/factories/:id?s=<fornitore>): stesso contenuto del drawer, con URL e breadcrumb. */
export default function FactoryPage() {
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const [sp] = useSearchParams();
  const q = useFactory(id);
  const [newAudit, setNewAudit] = useState(false);
  if (q.isLoading) return <Spin style={{ display: "block", margin: 48 }} />;
  if (q.error || !q.data) return <Alert type="error" showIcon message={q.error instanceof ApiError ? q.error.message : t("noResults")} />;
  const f = q.data;
  // fornitore del percorso: quello da cui si arriva (?s=), altrimenti quello di cui è sede, altrimenti il primo
  const sup = f.suppliers.find((s) => s.id === sp.get("s")) ?? f.suppliers.find((s) => s.isSeat) ?? f.suppliers[0];
  return (
    <div>
      <Crumbs
        items={[
          { label: t("suppliers"), to: "/suppliers" },
          ...(sup ? [{ label: sup.name, to: `/suppliers/${sup.id}` }] : []),
          { label: `${t("f_factory")} ${f.name}${f.isSeat ? ` (${t("f_seat")})` : ""}` },
        ]}
      />
      <PageHead title={<FactoryName f={f} />} />
      <FactoryView factoryId={f.id} supplierId={sup?.id} onNewAudit={() => setNewAudit(true)} />
      {newAudit && sup && <AuditFormModal open onClose={() => setNewAudit(false)} supplierId={sup.id} factoryId={f.id} onSaved={() => void q.refetch()} />}
    </div>
  );
}
